function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkraineMaksimsLoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 323.6 219.8",
    style: {
      enableBackground: "new 0 0 323.6 219.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 73.2,
    cy: -388.8,
    r: 43.3,
    fx: 81.395,
    fy: -360.865,
    gradientTransform: "matrix(1 0 0 -1 0 -324)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    style: {
      stopColor: "#b0dcc1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    style: {
      stopColor: "#abd9bd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    style: {
      stopColor: "#9dd3b2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    style: {
      stopColor: "#85c89f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#64ba85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    style: {
      stopColor: "#39a763"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    style: {
      stopColor: "#06903b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008d36"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 73.2,
    cy: 64.8,
    r: 43.3,
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6 103.7C43.3 98.3 32.1 80.2 30 64.8c-.6 16.1 11.4 35.8 31.3 41.7 21.6 6.4 41.6-5.4 49.7-20.6-9.9 13.3-26.5 24.5-49.4 17.8z",
    style: {
      fill: "#005f12"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 162.2,
    cy: -481.8,
    r: 43.3,
    fx: 176.171,
    fy: -453.979,
    gradientTransform: "matrix(1 0 0 -1 0 -324)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    style: {
      stopColor: "#b0dcc1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    style: {
      stopColor: "#abd9bd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    style: {
      stopColor: "#9dd3b2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    style: {
      stopColor: "#85c89f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#64ba85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    style: {
      stopColor: "#39a763"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    style: {
      stopColor: "#06903b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008d36"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 157.8,
    r: 43.3,
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.6 196.7c-18.3-5.4-29.5-23.5-31.6-38.9-.6 16.1 11.4 35.8 31.3 41.7 21.6 6.4 41.6-5.4 49.7-20.6-9.9 13.3-26.5 24.5-49.4 17.8z",
    style: {
      fill: "#005f12"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 250.2,
    cy: -481.8,
    r: 43.3,
    fx: 262.367,
    fy: -453.069,
    gradientTransform: "matrix(1 0 0 -1 0 -324)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    style: {
      stopColor: "#b0dcc1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    style: {
      stopColor: "#abd9bd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    style: {
      stopColor: "#9dd3b2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    style: {
      stopColor: "#85c89f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#64ba85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    style: {
      stopColor: "#39a763"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    style: {
      stopColor: "#06903b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008d36"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 250.2,
    cy: 157.8,
    r: 43.3,
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.6 196.7c-18.3-5.4-29.5-23.5-31.6-38.9-.6 16.1 11.4 35.8 31.3 41.7 21.6 6.4 41.6-5.4 49.7-20.6-9.9 13.3-26.5 24.5-49.4 17.8z",
    style: {
      fill: "#005f12"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.8 112c-3.5 0-6.7-.8-9.3-2.1-.6 1-1.8 1.7-3 1.7h-6c-1.3 0-2.5-.7-3.1-1.8-.8-1.5-1.3-3-1.8-4.4v-.1 2.8c0 1.9-1.6 3.5-3.5 3.5h-5.5c-.2 0-.4 0-.6-.1-.2 0-.4.1-.6.1h-6.1c-1.5 0-2.9-1-3.3-2.4l-1.3-3.8h-2.4l-1.1 3.7c-.4 1.5-1.8 2.5-3.4 2.5h-11.9c-1.7 0-3.1-1.2-3.4-2.8-.5 1.4-1.8 2.4-3.3 2.4H133c-1.1 0-2.2-.6-2.8-1.5-.6 1.1-1.8 1.8-3.1 1.8h-5.2c-1 0-1.9-.4-2.6-1.1s-1-1.7-.9-2.6l1.4-23.2c.1-1.9 1.7-3.3 3.5-3.3h7.8c1.5 0 2.9 1 3.4 2.4l1.4 4.5 1.7-4.6c.5-1.4 1.8-2.3 3.3-2.3h7.6c1.9 0 3.4 1.5 3.5 3.3l.3 6.2 2.4-7.1c.5-1.4 1.8-2.4 3.3-2.4h7.4c1.5 0 2.8.9 3.3 2.4l2.5 7.2v-6c0-1.9 1.6-3.5 3.5-3.5h5.5c1.9 0 3.4 1.5 3.5 3.3l1.5-1.9c.7-.9 1.7-1.4 2.8-1.4h6.8c1.3 0 2.5.7 3.1 1.9 2.7-1.5 5.9-2.3 9.5-2.3 2.3 0 4.6.3 6.4.8.5-.3 1.1-.4 1.7-.4h5.1c1.9 0 3.5 1.6 3.5 3.5V89l3.6-6c.6-1.1 1.8-1.7 3-1.7h5.8c.7 0 1.3.2 1.9.5.5-.3 1.2-.5 1.9-.5h7.8c1.5 0 2.9 1 3.4 2.4l1.4 4.5 1.7-4.6c.5-1.4 1.8-2.3 3.3-2.3h7.6c1.9 0 3.4 1.5 3.5 3.3l.3 6.2 2.4-7.1c.5-1.4 1.8-2.4 3.3-2.4h7.4c1.5 0 2.8.9 3.3 2.4l8.1 23.2c.4 1.1.2 2.3-.5 3.2s-1.7 1.5-2.9 1.5h-6.1c-1.5 0-2.9-1-3.3-2.4l-1.3-3.8h-2.4l-1.1 3.7c-.4 1.5-1.8 2.5-3.4 2.5h-11.9c-1.7 0-3.1-1.2-3.4-2.8-.5 1.4-1.8 2.4-3.3 2.4h-4.4c-1.1 0-2.2-.6-2.8-1.5-.6 1.1-1.8 1.8-3.1 1.8h-5.2c-.4 0-.8-.1-1.2-.2-.4.1-.8.2-1.2.2h-5.1c-1.9 0-3.5-1.6-3.5-3.5v-2.7l-2.9 4.6c-.6 1-1.8 1.6-3 1.6h-6.6c-.6 0-1.2-.2-1.8-.5-1.7.6-4.2 1-6.6 1zm45.7-11.3zm-116.9 0zm71.9-8.4c-2.2 0-4.7.7-4.7 4.1 0 3.3 2.6 4 4.8 4 1.5 0 3.1-.3 3.8-.6.2-.1.3-.1.5-.2v-6.4c-.2 0-.3-.1-.5-.2-.7-.2-2-.7-3.9-.7zM266 79.8c-15.4 0-26.1-10.4-26.1-25.4 0-3.7.6-7.1 1.8-10.2h-5.2v31.3c0 1.9-1.6 3.5-3.5 3.5h-10.2c-1.9 0-3.5-1.6-3.5-3.5V44.2h-6.7c1 2.9 1.6 6 1.6 9.4 0 15.4-11.1 26.1-27 26.1h-.1c-9.7 0-17.5-4.2-22-11v6.7c0 1.9-1.6 3.5-3.5 3.5h-10.2c-1.9 0-3.5-1.6-3.5-3.5V44.2h-4v6.3c0 11-1.3 21.8-10.3 26.7h-.1c-2.2 1.1-6 2.5-11.1 2.5-1.8 0-3.3-1.3-3.5-3.1l-1-8.1c-.2-1.9 1.1-3.7 3-3.9 2.1-.3 3.2-1.2 3.4-1.5 1-1 2.5-3.7 2.5-12V32.4c0-1.9 1.6-3.5 3.5-3.5h31.3c1.9 0 3.5 1.6 3.5 3.5v7.5c4.6-7.3 12.8-11.8 22.7-11.8 7.5 0 13.9 2.4 18.5 6.6v-2.3c0-1.9 1.6-3.5 3.5-3.5h36.3c1.9 0 3.5 1.6 3.5 3.5v1.1c4.5-3.5 10.3-5.4 16.9-5.4 15.5 0 26.3 10.5 26.3 25.5.2 15.4-10.9 26.2-26.8 26.2zm-133.9-5.7zm134.6-38.9c-11.6 0-19.7 7.9-19.7 19.2 0 11 7.6 18.3 19 18.3h.1c12.1 0 19.9-7.5 19.9-19.1 0-11.2-7.6-18.4-19.3-18.4zm-78.7 0c-11.6 0-19.7 7.9-19.7 19.2 0 11 7.6 18.3 19 18.3h.1c12.1 0 19.9-7.5 19.9-19.1 0-11.2-7.6-18.4-19.3-18.4zm-62.5 35.6.2 1.7c2.1-.3 3.7-.9 4.8-1.5 4.7-2.5 6.6-8.5 6.6-20.5v-9.8c0-1.9 1.6-3.5 3.5-3.5h11c1.9 0 3.5 1.6 3.5 3.5V72h3.1V36H134v15.1c0 8.5-1.4 13.8-4.4 16.9-1 1.1-2.5 2.1-4.1 2.8zM226.4 72h3.1V40.7c0-1.9 1.6-3.5 3.5-3.5h9.7v-1.3h-29.3v1.3h9.4c1.9 0 3.5 1.6 3.5 3.5V72h.1zm40.1-.1c-9.1 0-15.7-7.5-15.7-17.8 0-10.6 6.5-18 15.7-18 9.1 0 15.7 7.5 15.7 17.9 0 10.5-6.5 17.9-15.7 17.9zm0-28.8c-6 0-8.7 5.5-8.7 11 0 5.3 2.7 10.7 8.6 10.7 6.5 0 8.7-5.6 8.7-10.9.1-5.4-2.6-10.8-8.6-10.8zm-78.7 28.8c-9.1 0-15.7-7.5-15.7-17.8 0-10.6 6.5-18 15.7-18 9.1 0 15.7 7.5 15.7 17.9 0 10.5-6.4 17.9-15.7 17.9zm0-28.8c-6.4 0-8.7 5.9-8.7 11 0 5.3 2.7 10.7 8.6 10.7 6.5 0 8.8-5.9 8.8-10.9 0-5.4-2.7-10.8-8.7-10.8z",
    style: {
      fill: "#008d36"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 74.2,
    cy: -481.8,
    r: 43.3,
    fx: 86.905,
    fy: -455.012,
    gradientTransform: "matrix(1 0 0 -1 0 -324)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    style: {
      stopColor: "#b0dcc1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    style: {
      stopColor: "#abd9bd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    style: {
      stopColor: "#9dd3b2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    style: {
      stopColor: "#85c89f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#64ba85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    style: {
      stopColor: "#39a763"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    style: {
      stopColor: "#06903b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008d36"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 74.2,
    cy: 157.8,
    r: 43.3,
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6 196.7c-18.3-5.4-29.5-23.5-31.6-38.9-.6 16.1 11.4 35.8 31.3 41.7 21.6 6.4 41.6-5.4 49.7-20.6-9.9 13.3-26.5 24.5-49.4 17.8z",
    style: {
      fill: "#005f12"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.5 150.7c-2.6.3-4.9-1-5.1-3.1-.2-2.3 1.9-4.4 4.2-4.9 2.4-.5 4.5 1 5 3.5.5 2.3-.2 2.7-.2 2.7-.6.6-1 .9-1.6 1.2-1.1.4-2.3.6-2.3.6zm6.1 30.4c-2.2 0-4.4-1.8-5-4-2.1-8-3.1-12.8-4.5-20.1-.4-2 1.3-3.6 3.8-3.9.3 0 .5-.1.8-.1 2.5-.3 5 .8 5.5 2.8 1.7 7.1 2.4 12.5 3.7 20.9.3 2.4-1.3 4.3-3.5 4.4h-.8z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92 164c-.3-1.7.1-2.9 1-3.4.8-.4 5.2-1.7 5.5-2.4 0 0 0-.1-.4-1.6-.4-1.3-2-2-4.7-1.5-1.7.3-3.6 1.2-5 2.2-.3-.5-.4-.8-.7-1.3-1.1-1.8-.2-4.1 1.7-5 0 0 1.4-.6 5.1-1.4 6.6-1.5 10.4 0 11.6 3.2 1.1 2.8-.2 5.9-3.5 7.9 0 .1 1.8.5 3.8.8 0 0 3.1.5 3.2 3.7.1 5.3-5.5 11.5-11.9 13.8-3 1.1-5.9 1.1-8.3.4.1-.8.1-1.2.2-2 .3-2.4 2.2-3.7 4.7-4l2-.5c3.9-1.1 4.8-3.1 4.7-4.5-.1-2.2-2.5-2.5-5.3-1.9-1.9.4-3.4-.8-3.7-2.5z",
    style: {
      fill: "#fff"
    }
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M95.9 166.6c.5-.1.9-.1 1.4-.2-.8-.1-1.6 0-2.6.2.4.1.8.1 1.2 0zm-1.2-11.5c-.7-.1-1.5-.1-2.5.1-1.3.3-3.1 1-4.3 1.7.3.5.1 0 .5.6 1.4-1 3.6-2 5.3-2.4.4.1.7.1 1 0zm11.9 6.4c-2-.3-3.8-.7-3.8-.8 3.3-2 4.6-5.1 3.5-7.9-1-2.5-3.3-4.1-7.5-3.9 3.3.2 5.2 1.7 6.1 3.9 1.1 2.8-.2 5.9-3.5 7.9 0 .1 1.8.5 3.8.8 0 0 3.1.5 3.2 3.7.1 5.3-5.5 11.5-11.9 13.8-1.4.5-2.7.7-4 .8 1.7.1 3.6-.1 5.5-.8 6.4-2.3 12-8.5 11.9-13.8-.2-3.2-3.3-3.7-3.3-3.7zm-29.5-8.4c-.1 0 .3-.1.2-.1 2 .2 3.4 1.3 3.8 2.9 1.7 7.1 2.4 12.5 3.7 20.9.3 2.3-1.2 4.1-3.2 4.3.2 0 .3.1.5.1h.7c2.2-.1 3.8-2 3.5-4.4-1.2-8.5-1.9-13.9-3.7-20.9-.5-2-3-3.1-5.5-2.8zm2.9-7.5c-.5-2.4-2.6-3.4-4.8-3.1 2.1.1 4.1 1.8 4.1 3.8 0 2.4-1 3-2.5 3.7-.9.4-1.8.6-2.1.7.4 0 .8.1 1.3 0 0 0 1.2-.2 2.3-.7 1-.5 2.2-2 1.7-4.4z",
    style: {
      fill: "#063"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146.4 167.1c-2-.7-3.1-2.9-2.5-5 .5-1.8.7-2.8 1.3-4.7.7-2.2-.4-4.4-2.3-4.9-5.2-1.4-7.4-2.2-12.7-2.7-1.9-.2-3.1-1.5-2.4-3.2.2-.5.3-.8.6-1.4.7-1.7 2.6-4.4 4.2-6 9.4-9.4 15.6-15.5 26.6-18.8 1.8-.5 4.8-.7 6.6-.3 3.3.9 4.9 1.5 7.6 3.2 1.5.9 1.9 3.2 1.1 4.8-3.5 6.7-5.5 9.4-9.4 16.8-.9 1.7-.4 3.7 1 4.4s1.9 2.7 1.1 4.4l-1.2 2.4c-.8 1.8-2.7 2.8-4.2 2.3s-3.4.7-4.2 2.7c-.7 1.8-1 2.7-1.6 4.5-.7 2-2.8 3.4-4.8 2.9-1.9-.4-2.9-.7-4.8-1.4zm.6-25.5c2.1.3 4.7-.4 5.8-2.3.3-.5.4-.7.7-1.1 1.1-1.8 3-4.5 4.2-6 0 0 2.2-2.8 4.2-5.2-.2-.1-1.6.6-3.3 1.5 0 0-3.7 1.1-7.9 4.4-2.4 1.9-3.5 2.9-5.6 5-1.6 1.6-2.9 3-2.9 3s1.5.2 3.5.5c.4 0 .7.1 1.3.2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5 149.1c-.6 0-1.1-.2-1.5-.5.4.6 1.2 1 2.2 1.1 5.3.5 7.4 1.3 12.7 2.7.6.2 1.1.5 1.5 1-.4-.9-1.1-1.7-2.1-1.9-5.3-1.3-7.4-2-12.8-2.4zm15.5-11.3c2.1-2.1 3.2-3.1 5.6-5 4.1-3.2 7.9-4.4 7.9-4.4.5-.3 1-.5 1.4-.7.5-.5 1-1.1 1.4-1.6-.2-.1-1.7.6-3.4 1.5 0 0-3.9 1.3-8 4.5-2.4 1.9-3.5 2.9-5.6 4.9-1.6 1.6-2.9 3-2.9 3s.4.1 1.2.2c.6-.5 1.4-1.4 2.4-2.4zm29.3-13.2c.2.8.1 1.7-.3 2.5-3.6 6.7-5.6 9.4-9.6 16.9-.7 1.4-.5 2.9.4 3.9-.3-.9-.3-1.9.2-2.8 3.9-7.4 5.9-10.2 9.4-16.8.6-1.2.5-2.7-.1-3.7zm-7.6 25.4c.3.9.3 1.8-.2 2.8l-1.2 2.4c-.8 1.8-2.7 2.8-4.2 2.3s-3.5.7-4.2 2.7c-.7 1.8-1 2.7-1.7 4.5-.7 2.1-2.8 3.4-4.8 2.9s-3-.8-4.9-1.5c-.6-.2-1.1-.6-1.5-1.1.4 1 1.2 1.8 2.2 2.1 1.9.7 2.9.9 4.9 1.4s4.1-.8 4.8-2.9c.6-1.8.9-2.7 1.6-4.5.8-2 2.7-3.2 4.2-2.7s3.4-.5 4.2-2.3c.5-1 .7-1.5 1.2-2.4.7-1.3.5-2.8-.4-3.7z",
    style: {
      fill: "#063"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m157.9 84.8-7.8 23.2h5.8l1.8-6.2h7.5l2.1 6.2h6.1l-8.1-23.2h-7.4zm.7 13 1.6-5c.4-1.3.8-2.9 1.1-4.2h.1c.4 1.3.8 2.9 1.3 4.2l1.7 5h-5.8zm-17.8-13-2.7 7.5c-.9 2.5-1.7 5.7-2.5 8.5h-.1c-.5-2.8-1.3-5.8-2.1-8.4l-2.4-7.6h-7.8l-1.4 23.2h5.2l.4-9.1c.1-3.1.2-6.9.4-10.3h.1c.7 3.2 1.5 6.7 2.3 9.7l2.7 9.2h4.3l3.1-9.3c1-3.1 2.1-6.5 3-9.7h.1c0 3.7.1 7.2.2 10.2l.3 9.1h5.5l-1.2-23.2h-7.4v.2zm44.9 10.1 9-10.2h-6.8l-7.3 9.5h-.5v-9.5h-5.5V108h5.5v-9.7h1.2c3.2 0 4.4 2.1 5.3 4.7.6 1.7 1.1 3.4 1.9 5h6c-1.2-2.4-2.1-5-3.1-7.6-1-2.7-2.5-4.8-5.7-5.5zm71.9-10.1-2.7 7.5c-.9 2.5-1.7 5.7-2.4 8.5h-.1c-.5-2.8-1.3-5.8-2.1-8.4l-2.4-7.6h-7.8l-1.4 23.2h5.2l.4-9.1c.1-3.1.2-6.9.4-10.3h.1c.7 3.2 1.5 6.7 2.3 9.7l2.7 9.2h4.4l3.1-9.3c1-3.1 2.1-6.5 3-9.7h.1c0 3.7.1 7.2.2 10.2l.3 9.1h5.5l-1.2-23.2h-7.6v.2zm24.5 0h-7.4l-7.8 23.2h5.8l1.8-6.2h7.5l2.1 6.2h6.1l-8.1-23.2zm-6.7 13 1.6-5c.4-1.3.8-2.9 1.1-4.2h.1c.4 1.3.8 2.9 1.3 4.2l1.7 5h-5.8zm-67.9-9c2.2 0 4 .5 5.2 1l1.2-4.3c-1.1-.6-3.5-1.2-6.6-1.2-7.8 0-13.8 4.7-13.8 12.4 0 6.6 4.6 11.7 13.4 11.7 3.2 0 5.7-.6 6.8-1.1l-.9-4.2c-1.2.5-3.2.9-5.1.9-5.3 0-8.3-3.2-8.3-7.6-.2-5 3.4-7.6 8.1-7.6zM225 94c-1.6 2.8-3.3 5.8-4.7 8.8h-.1c.2-3.3.2-6.9.2-10.5v-7.5h-5.1V108h6.6l5.2-8.2c1.6-2.6 3.3-5.7 4.5-8.7h.1c-.4 3.3-.4 6.3-.4 9.6v7.4h5.1V84.8h-5.8L225 94zm-37.7-17.7c14.1 0 23.5-9.2 23.5-22.6 0-12.6-8.6-22-22.8-22-13.7 0-23.2 9.5-23.2 22.8 0 12.3 8.7 21.8 22.5 21.8zm.5-36.7c7.7 0 12.2 6.6 12.2 14.4 0 8.3-4.6 14.4-12.2 14.4h-.1c-7.4 0-12.1-6.3-12.1-14.3 0-8.1 4.5-14.5 12.2-14.5zM266 76.3c14.1 0 23.5-9.2 23.5-22.6 0-12.6-8.6-22-22.8-22-13.7 0-23.2 9.5-23.2 22.8 0 12.3 8.7 21.8 22.5 21.8zm.5-36.7c7.7 0 12.2 6.6 12.2 14.4 0 8.3-4.6 14.4-12.2 14.4h-.1c-7.4 0-12.1-6.3-12.1-14.3 0-8.1 4.5-14.5 12.2-14.5zM132.1 74.1c6.9-3.7 8.5-12.1 8.5-23.6v-9.8h11v34.8h10.2V32.4h-31.3v18.7c0 5.9-.7 11.7-3.4 14.5-1.1 1.2-3.1 2.3-5.6 2.6l1 8.1c4-.1 7.3-1 9.6-2.2zm90.8 1.4h10.2V40.7h13.2v-8.3H210v8.3h13v34.8h-.1z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.1 37.9c-1.1.9-2.2 1-3.9-.1-1.7-1.1-4.1-2.5-9.7-3.7-3.7-.8-4.7.4-6.1 2.1-1.1 1.4-.7 2.7.1 3.1l.9.4c3.4 1.8 6.2 3 7.5 6.4 1.4 3.6 1.4 9.3-2.4 14.9-6.1 9.1-12.5 10.7-20 8.4-4.8-1.5-8.8-4.8-10-7-.7-1.2-.9-2.9-.5-5.1.4-2.5 1.5-5 2-4.5 0 0 2.8 3.3 6.2 4.7 3.6 1.4 9.5 1.8 11.6-3 1.7-4.1 1.8-8.1-7.3-11-1.9-.6-3.9-1.1-5.3-1.3 4.8-7.9 12-13 15.9-14.2s6.1-1.4 11.4-.4c5.4 1 12.2 4.1 11.4 6.6-.2 1.2-.7 2.7-1.8 3.7z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.5 39.7c-.8-.4-1.7-1.4-1.7-1.4s.5 1.1.4 1c.4.5 1 .9 1.9 1.3 2.5 1.3 4.5 2.3 6 4-1.4-2.2-3.7-3.4-6.6-4.9zm-5.6 14.8c-2.1 4.9-8 4.5-11.6 3-3.4-1.4-6.2-4.7-6.2-4.7-.5-.6-1.7 2-2 4.5-.3 2.2-.1 3.8.5 5.1.1.2.4.5.6.8-.6-1.2-.8-2.8-.5-4.9.3-2.5 1.5-5 2-4.5 0 0 2.8 3.3 6.2 4.7 3.6 1.4 9.5 1.8 11.6-3 1-2.4 1.4-4.8-.2-6.9 1 1.8.5 3.9-.4 5.9zm14.7-26.9c-5.4-1-7.5-.8-11.4.4-3.9 1.2-11.1 6.3-15.9 14.2.3.1.8.2 1.2.2C51.3 35 58.1 30.1 61.9 29c3.9-1.2 6.1-1.4 11.4-.4 4 .7 8.8 2.6 10.6 4.6-.8-2.3-6.6-4.8-11.3-5.6z",
    style: {
      fill: "#063"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M252.5 132.7c-.8 1.2-1.8 1.6-3.7 1-1.9-.5-4.7-1.2-10.3-.7-3.7.3-4.4 1.8-5.2 3.8-.7 1.7.2 2.8 1 2.9l1 .2c3.8.7 6.8 1.1 9 4 2.4 3 4.1 8.5 2.1 14.9-3.2 10.5-8.8 13.9-16.6 13.9-5 0-9.8-2-11.6-3.8-1-1-1.7-2.5-2-4.7-.4-2.4 0-5.3.6-4.9 0 0 3.6 2.3 7.3 2.7 3.8.3 9.6-1 10.2-6.3.5-4.5-.6-8.3-10.2-8.4-1.9 0-4 .1-5.5.3 2.3-9 7.7-16 11-18.2 3.4-2.3 5.4-3.1 10.8-3.7 5.4-.6 12.9-1.6 12.9 1.1.1 1.1 0 4.7-.8 5.9z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.3 139.9c-.9-.2-2-.8-2-.8-.1 0 .8.9.7.9.5.4 1.3.6 2.2.7 2.7.5 5 .9 6.9 2.1-2.1-1.8-4.7-2.3-7.8-2.9zm-1 15.8c-.6 5.2-6.4 6.6-10.2 6.3-3.7-.3-7.3-2.7-7.3-2.7-.7-.4-1 2.4-.7 4.9.3 2.2 1 3.7 2 4.7.2.2.6.4.8.6-.9-1-1.6-2.5-1.9-4.5-.4-2.4 0-5.3.6-4.9 0 0 3.6 2.3 7.3 2.7 3.8.3 9.6-1 10.2-6.3.3-2.6-.1-5-2.2-6.6 1.5 1.5 1.6 3.6 1.4 5.8zm6.2-30c-5.4.6-7.4 1.4-10.8 3.7-3.4 2.3-8.8 9.3-11 18.2.3-.1.8-.1 1.2-.1 2.4-8.5 7.5-15.2 10.8-17.4 3.4-2.3 5.4-3.1 10.8-3.7 4-.5 9.2-1.9 11.6-.6-1.6-1.9-7.9-.7-12.6-.1z",
    style: {
      fill: "#063"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkraineMaksimsLoto);
export default __webpack_public_path__ + "static/media/ukraine_maksims_loto.ef319f9898d2f34164e9a23badb06084.svg";
export { ForwardRef as ReactComponent };